"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.patientsSync = void 0;
const store_1 = require("../../../../patients/store");
const store_2 = require("../../../../sites/modules/sites-list/store");
exports.patientsSync = (folder) => {
    const rows = require(`../../../../../../../data/sheets/${folder}/patients.json`);
    const skipRows = [1, 2, 3]; // Hardcoded rows to skip.
    const { sites: { value: sites = [] } } = store_2.sitesListStore;
    const existingPatients = new Set();
    const firstRow = Object.values(rows.patients[0]).map((e) => e);
    const siteName = firstRow[firstRow.length - 2];
    const sitesMap = sites.map((site, i) => site.displayName);
    const site = sitesMap.indexOf(siteName);
    /**
     * This section was used for syncing patients from Google sheets. It
     * needs to be updated to reflect the separation of patient and insurance.
     */
    return Promise.all(Object.values(rows.patients).map(async (row, i) => {
        const patient = {
            address: '',
            address2: '',
            birthDate: Date.now(),
            city: '',
            confirmNoInsurance: false,
            email: '',
            firstName: '',
            gender: '1',
            insuranceId: '',
            insuranceRelationship: 0,
            lastName: '',
            middleName: '',
            missingInsurance: false,
            notes: '',
            payerPersonCode: '',
            payerCoverageType: '',
            payerGroupId: '',
            payerIdCount: '',
            payerIdQualifier: '',
            payerPhone: '',
            pcn: '',
            phone: '',
            sites: [],
            state: '',
            zip: '00000',
        };
        const toTitleCase = (str) => {
            const newStr = str.toLowerCase().split(' ');
            for (let i = 0; i < newStr.length; i++) {
                newStr[i] = newStr[i].charAt(0).toUpperCase() + newStr[i].slice(1);
            }
            return newStr.join(' ');
        };
        if (row.name && skipRows.indexOf(i + 1) === -1) {
            const fullName = row.name.includes(',')
                ? row.name.replace(',', '').split(' ')
                : row.name.split(' ').reverse();
            if (fullName.length > 1) {
                patient.firstName = toTitleCase(fullName[1]);
                patient.lastName = toTitleCase(fullName[0]);
                if (existingPatients.has(`${patient.firstName} ${patient.lastName}`)) {
                    return null;
                }
                patient.zip = row.zip ? row.zip : patient.zip;
                patient.birthDate = row.dob ? row.dob : patient.birthDate;
                const siteToAdd = sites[site];
                patient.sites.push(siteToAdd);
                existingPatients.add(`${patient.firstName} ${patient.lastName}`);
                return store_1.patientsStore.createPatient(patient, true);
            }
        }
        return null;
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/sync/modules/google-sync/modules/google-patients.ts
// module id = 4138
// module chunks = 0